import { Moon, Sun, Monitor } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@pracownik/ui";
import { useTheme, type ThemePreference } from "@/lib/theme";

export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation("common");
  const { theme, setTheme } = useTheme();
  const options: Array<{ value: ThemePreference; icon: typeof Sun; label: string }> = [
    { value: "light", icon: Sun, label: t("theme.light") },
    { value: "dark", icon: Moon, label: t("theme.dark") },
    { value: "system", icon: Monitor, label: t("theme.system") },
  ];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t("theme.label")} className={className}>
          <Sun className="size-4 dark:hidden" />
          <Moon className="size-4 hidden dark:block" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {options.map((o) => (
          <DropdownMenuItem
            key={o.value}
            onSelect={() => setTheme(o.value)}
            data-active={theme === o.value}
          >
            <o.icon />
            <span className="flex-1">{o.label}</span>
            {theme === o.value && <span aria-hidden className="size-1.5 rounded-full bg-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
